@use "foundation/colors.scss";
@use "foundation/responsive.scss";
@use "foundation/mixins.scss";

.feedback-bump {
  background-color: #000;
  color: colors.$primary-white;
  position: fixed;
  bottom: 0;
  left: 2rem;
  width: 411px;
  padding: 0.8rem 1rem 0 1rem;
  z-index: 3;
  border-radius: 1rem 1rem 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include responsive.phone {
    left: 0;
    right: 0;
    width: 100vw;
    z-index: 1002; // 12 more than connect_button, 1 more than zendesk help widget
  }

  .close {
    position: absolute;
    right: 1.2rem;
    top: 1rem;
    cursor: pointer;

    g {
      stroke: colors.$neutrals-grey;
    }

    & + .stars {
      margin-top: 1.5rem;
    }
  }

  h4 {
    font-weight: 800;
    margin-bottom: 1em;

    &.middle {
      margin-top: 0;
    }
  }

  .stars {
    width: 264px;
    display: flex;
    flex-direction: row;
    align-self: center;
    justify-content: space-around;
    margin: 0.8rem auto 1.6rem auto;

    svg {
      cursor: pointer;
    }

    :global svg.rated {
      cursor: unset;
    }

    :global svg.hovered {
      path {
        stroke: colors.$neutrals-dark-grey;
      }
    }
  }

  p {
    text-align: center;
    font-size: 0.8rem;
    width: 50%;

    @include responsive.phone {
      font-size: 1rem;
    }

    &.help {
      margin: 1.5rem auto;
      width: 100%;

      a {
        color: colors.$primary-white;
      }
    }
  }

  .tags {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    .tag {
      background: colors.$neutrals-dark-grey;
      color: colors.$primary-white;
      font-size: 0.8rem;
      font-weight: 700;
      line-height: 1.2rem;
      border-radius: 8px;
      flex: none;
      order: 1;
      flex-grow: 0;
      margin: 0.2rem;
      padding: 0.4rem 0.8rem;
      cursor: pointer;

      @include responsive.phone {
        font-size: 0.875rem;
      }

      &.tagged {
        background-color: colors.$primary-white;
        color: colors.$primary-eerie-black;
      }
    }
  }

  .advance-step {
    display: flex;
    padding: 1.5rem;
  }

  .text-box {
    @include mixins.placeholder(colors.$neutrals-grey);
    color: colors.$neutrals-grey;
    display: flex;
    font-size: 0.8rem;
    resize: none;
    border-color: colors.$neutrals-grey;
    background-color: colors.$primary-eerie-black;

    &::selection {
      background-color: colors.$neutrals-grey;
    }

    &:active:not(:disabled),
    &:focus:not(:disabled) {
      color: colors.$primary-white;
      border-color: colors.$primary-white;
    }
  }
}
